module.exports = __webpack_public_path__ + "img/normal.dfed0f42.png";